import { faCircleCheck, faCircleXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Skeleton } from "@mui/material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PublicPortalTheme } from "@publicPortal/theme/MuiPublicPortal.module";
import { ResultBoardProps } from "@shared/mirage/core/contracts/ResultBoard";
import { useNavigate } from "react-router-dom";
import Board from "../board/Board";

const ResultBoard: React.FC<ResultBoardProps> = (props: ResultBoardProps) => {
    const navigate = useNavigate();
    return (
        <Board key={"result-board"} headerText={props.headerText} size="small">
            <Stack spacing={4} justifyContent={"center"} alignItems={"center"}>
                {props.loading ? (
                    <>
                        <Skeleton variant={"circular"} width={"2.5rem"} height={"2.5rem"} />
                        <Skeleton variant={"rounded"} width={"15rem"} height={"2rem"} />
                        <Skeleton variant={"rounded"} width={"7.5rem"} height={"2rem"} />
                    </>
                ) : (
                    <>
                        {props.success ? (
                            <FontAwesomeIcon style={PublicPortalTheme.icons.sizeL} color={PublicPortalTheme.palette.success.main} icon={faCircleCheck} />
                        ) : (
                            <FontAwesomeIcon style={PublicPortalTheme.icons.sizeL} color={PublicPortalTheme.palette.error.main} icon={faCircleXmark} />
                        )}
                        <Typography>{props.message}</Typography>
                        {props.children}
                        <Button onClick={() => navigate(props.buttonNavTo)}>{props.buttonLabel}</Button>
                    </>
                )}
            </Stack>
        </Board>
    );
};

export default ResultBoard;
